<template>
  <div>
    <header-component></header-component>
    <!-- 正直良くわからないが、 slot を使うと v-data が消える模様 -->
    <main class="members-register-flow-layout">
      <slot></slot>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "./HeaderComponent";
import FooterComponent from "./FooterComponent";

export default {
  components: { HeaderComponent, FooterComponent }
};
</script>
<style lang="scss">
// 正直良くわからないが、 slot を使うと v-data が消えるようなので
//（つまり scoped をつけても無意味になるようなので、）
// ここだけはちゃんとクラスで指定しないといけない。
main.members-register-flow-layout {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 10px;
  box-sizing: border-box;
  font-size: 14px;
  img {
    width: auto;
      max-width: 100%;
  }

  .warning {
    color: red;
    margin: 12px 0;
    &.bottom {
      text-align: center;
    }
  }

  .flows {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 -5px 0 -5px;
    .flow {
      position: relative;
      flex-basis: calc(20% - 1em);
      flex-grow: 0;
      flex-shrink: 0;
      padding: 10px 0;
      box-sizing: border-box;
      background: #eee;
      text-align: center;
      line-height: 1em;
      font-size: 10px;
      &.active {
      background: #f99;
        color: white;
      }
    }
    .flow::before,
    .flow::after {
      content: "";
      position: absolute;
      top: 50%;
      margin-top: -1.5em;
    }
    .flow::before {
      left: -0.5em;
      border-top: solid 1.5em #eee;
      border-bottom: solid 1.5em #eee;
      border-left: solid 0.5em #fff;
    }
    .flow::after {
      right: -0.5em;
      border-top: solid 1.5em #fff;
      border-bottom: solid 1.5em #fff;
      border-left: solid 0.5em #eee;
    }
    .flow.active::before {
      border-top: solid 1.5em #f99;
      border-bottom: solid 1.5em #f99;
    }
    .flow.active::after {
      border-left: solid 0.5em #f99;
    }
  }
  .add,
  .remove {
    margin-top: 16px;
  }
  .panel {
    margin-top: 16px;
    padding: 16px 10px;
    background: #eee;
    box-shadow: 0 3px 4px -2px rgba(0, 0, 0, 0.5);
    line-height: 1.5em;
    font-size: 14px;
    .parts {
      // margin: 20px;
      .part {
        display: block;
        margin: 0 auto;
        .header {
          flex: 0 0 300px;
        }
        :not(.header) {
          flex: 1 1 auto;
        }
        &:not(:first-of-type) {
          margin-top: 20px;
        }
        .date {
          input[type="number"] {
            width: 5em;
          }
        }
        input[type="text"],
        input[type="date"],
        input[type="tel"],
        input[type="number"],
        textarea {
          max-width: 100%;
          border-radius: 5px;
          &:not(:last-of-type) {
            margin-bottom: 12px;
          }
        }
        textarea {
          box-sizing: border-box;
          width: 100%;
          min-height: 10em;
          padding: 8px;
        }
        .remain {
          color: gray;
        }
        .note {
          margin-top: 8px;
        }
      }
    }
    .secure {
      margin-top: 16px;
    }
  }
  .buttons {
    margin-top: 16px;
    display: flex;
    .button {
      margin: auto;
      text-align: center;
      background: #7dc7ae;
      // あまり使いたくないが…。
      color: white !important;
      border-radius: 20px;
      font-size: 16px;
      padding: 10px 40px;
      box-shadow: 2px 2px 2px rgba(42, 139, 47, 0.534);
      line-height: 1.2em;
      border: none;
    }
  }
  @media (max-width: 1200px) {
  }
  @media (min-width: 578px) {
    font-size: 16px;
    .flows {
      margin: 0;
      .flow {
        flex-basis: calc(20% - 2em);
        padding: 1em 0.5em;
        font-size: 14px;
      }
      .flow::before,
      .flow::after {
        margin-top: -1.5em;
      }
      .flow::before {
        border-top: solid 1.5em #eee;
        border-bottom: solid 1.5em #eee;
        border-left: solid 1em #fff;
      }
      .flow::after {
        border-top: solid 1.5em #fff;
        border-bottom: solid 1.5em #fff;
        border-left: solid 1em #eee;
      }
      .flow.active::before {
        border-top: solid 1.5em #f99;
        border-bottom: solid 1.5em #f99;
      }
      .flow.active::after {
        border-left: solid 1em #f99;
      }

    }
  }
  @media (min-width: 768px) {
    .flows {
      .flow {
        font-size: 16px;
      }
    }
    .panel {
      padding: 16px;
      font-size: 16px;
      .parts{
        .part{
          display: flex;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MembersRegisterFlowLayout.vue